import { supabase, ServiceResponse, handleServiceCall } from './supabase';

export interface UserSettings {
    pda_model?: string;
    scan_action?: string;
    scan_extra?: string;
    reprint_mode?: 'copy' | 'update';
    weight_audit_abs?: number;
    weight_audit_percent?: number;
    export_mode?: 'anomaly' | 'all';
    theme_mode?: 'system' | 'light' | 'dark';
    language?: string;
    bluetooth_devices?: any[];
    print_size?: string;
    print_protocol?: string;
}

export const UserSettingsService = {
    async getSettings(userId: string): Promise<ServiceResponse<UserSettings>> {
        const response = await handleServiceCall<{ settings: UserSettings }>(
            supabase.from('user_settings')
                .select('settings')
                .eq('user_id', userId)
                .single()
        );

        if (response.success && response.data) {
            return { success: true, data: response.data.settings, error: null };
        }

        // If no settings yet, return default
        return { success: true, data: {} as UserSettings, error: null };
    },

    async saveSettings(userId: string, settings: Partial<UserSettings>): Promise<ServiceResponse<void>> {
        // Fetch existing to preserve other keys if any
        const { data: existing } = await supabase
            .from('user_settings')
            .select('settings')
            .eq('user_id', userId)
            .maybeSingle(); // Does not error if not found

        const newSettings = { ...(existing?.settings || {}), ...settings };

        return handleServiceCall(
            supabase.from('user_settings')
                .upsert({
                    user_id: userId,
                    settings: newSettings,
                    updated_at: new Date().toISOString()
                }, { onConflict: 'user_id' })
        );
    }
};
